import { mapActions, mapGetters } from 'vuex'
import { TRACKING_EVENTS } from '@/constants/tracking'
import LOGGING_EVENTS from '@/constants/logging-events'
import CHECKOUT_EVENTS from '@/constants/checkout-events'
import { sendViaPostMessage } from '@/utils/iframe-support'
import { appendQuerystringToUrl } from '@/utils/query-string'
import ConfirmDialog from '@/components-v4/cancel-button/confirm-dialog.vue'
import logger from '@/utils/logger'
import * as mobileLib from '@/utils/mobile'

export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      showConfirm: false,
      redirecting: false,
      redirectTimeoutId: null,
    }
  },
  computed: {
    ...mapGetters('application', ['isEmbedded']),
    ...mapGetters('mfa', ['mfaSessionId']),
    ...mapGetters('session', {
      sessionCancelUrl: 'cancelUrl',
      checkoutId: 'checkoutId',
      orderId: 'orderId',
    }),
    cancelUrl() {
      const stageQuerystring = { stage: this.stage }
      const hasStage = this.stage && this.stage !== ''

      if (!this.sessionCancelUrl) {
        return null
      }

      return hasStage
        ? appendQuerystringToUrl(this.sessionCancelUrl, stageQuerystring)
        : this.sessionCancelUrl
    },
  },
  methods: {
    ...mapActions('session', ['cancelCheckoutSession']),
    ...mapActions('mfa', ['cancelMfaSession']),
    showPopup() {
      this.trackEvent(TRACKING_EVENTS.CANCEL_ORDER_CLICKED.EVENT_NAME)
      this.trackEvent(TRACKING_EVENTS.CANCEL_ORDER_POPUP_SHOWN.EVENT_NAME)
      logger.debug(`Clicked to cancel order.`, {
        checkoutId: this.checkoutId,
        orderId: this.orderId,
      })
      this.$logger.log(LOGGING_EVENTS.CANCEL_ORDER_CLICK)

      if (this.disabled) {
        return
      }

      this.showConfirm = true
    },
    hiddePopup() {
      this.showConfirm = false
    },
    async processCancelOrder() {
      if (this.redirecting) {
        return
      }

      // Cancel MFA session
      if (this.mfaSessionId) {
        await this.cancelMfaSession({ mfaSessionId: this.mfaSessionId })
      }

      await this.cancelCheckoutSession()

      this.trackEvent(TRACKING_EVENTS.ORDER_CANCELED.EVENT_NAME)

      this.$logger.log(LOGGING_EVENTS.CANCEL_ORDER_SUCCESS)

      mobileLib.sendMessage(this.orderId, 'instore_checkout_cancelled', 'back')

      if (this.isEmbedded) {
        return this.handleSendEventCancelation()
      }

      return this.handleRedirectToCancelation()
    },
    handleSendEventCancelation() {
      const data = { cancel: true, callbackUrl: this.cancelUrl }

      sendViaPostMessage(CHECKOUT_EVENTS.ORDER_CANCELED, data)
    },
    handleRedirectToCancelation() {
      if (!this.cancelUrl) {
        return
      }

      this.redirecting = true
      const cancelUrl = this.cancelUrl

      // Redirect to cancel URL
      this.$redirect(cancelUrl)
    },
  },
}
